import { render, staticRenderFns } from "./startorstopLog.vue?vue&type=template&id=31b5c96b&scoped=true"
import script from "./startorstopLog.vue?vue&type=script&lang=js"
export * from "./startorstopLog.vue?vue&type=script&lang=js"
import style0 from "./startorstopLog.vue?vue&type=style&index=0&id=31b5c96b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5c96b",
  null
  
)

export default component.exports